import React from 'react'
import { useState, useEffect } from 'react'
import visa from '../../assets/visa/visa.jpg'
import chandr2 from '../../assets/visa/chandr.png'
import form from '../../assets/visa/form1.jpg'
import { useNavigate } from 'react-router-dom';
import { FiArrowUpRight } from "react-icons/fi"
import { IoMdAirplane } from "react-icons/io";
import { FaHeartPulse } from "react-icons/fa6";
import { BiSolidBriefcase } from "react-icons/bi";
import { FaIdCard } from "react-icons/fa6";
import Loader from "../../components/common/Loader";
import { FileText, Shield, BadgeCheck, MessageSquare, Users, Clock } from 'lucide-react';
import { Phone, Globe, Mail } from "lucide-react"
// import { useState,useEffect } from 'react';
import { useCreateVisaContactMutation } from '../../store/api/contact'
import VisaAnimation from '../../../src/assets/animations/Plane Ticket Animation.json'

function Visa() {
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        fullName: '',
        phoneNumber: '',
        address: '',
        age: '',
        gender: '',
        visaType: '',
        travel: '',
        travelStartDate: '',
        travelEndDate: '',
        reasonForTravel: '',
        pastVisaRejections: '',
        fastTrackServices: false,
    });
    const [createVisaContact, { isLoading, isError, isSuccess, error }] = useCreateVisaContactMutation();

    useEffect(() => {
        setTimeout(() => setLoading(false), 2000); // 2 seconds
    }, []);
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const submissionData = {
                full_name: formData.fullName,
                phone_number: formData.phoneNumber,
                address: formData.address,
                age: parseInt(formData.age),
                gender: formData.gender,
                visa_type: formData.visaType,
                travel_alone: formData.travel,  // Make sure you have this field in your form
                travel_start_date: formData.travelStartDate,
                travel_end_date: formData.travelEndDate,
                reason_for_travel: formData.reasonForTravel,
                past_visa_rejections: formData.pastVisaRejections,
                fast_track_services: formData.fastTrackServices,
            };

            const result = await createVisaContact(submissionData).unwrap();
            console.log("Form submitted successfully:", result);

            // Reset form
            setFormData({
                fullName: "",
                phoneNumber: "",
                address: "",
                age: "",
                gender: "",
                visaType: "",
                travelAlone: "",
                travelStartDate: "",
                travelEndDate: "",
                reasonForTravel: "",
                pastVisaRejections: "",
                fastTrackServices: false,
            });

        } catch (error) {
            console.error("Failed to submit form:", error);
            alert("Failed to submit application. Please try again.");
        }
    };

    const navigate = useNavigate()
    const visaTypes = [
        {
            icon: <IoMdAirplane className="w-8 h-8 text-gray-700" />,
            title: "Tourist Visa",
            description: "Explore New Destinations With Ease.",
        },
        {
            icon: <BiSolidBriefcase className="w-8 h-8 text-gray-700" />,
            title: "Business Visa",
            description: "Facilitate Your Business Trips Effortlessly.",
        },
        {
            icon: <FaHeartPulse className="w-8 h-8 text-gray-700" />,
            title: "Medical Visa",
            description: "Access Healthcare Services Abroad Smoothly.",
        },
        {
            icon: <FaIdCard className="w-8 h-8 text-gray-700" />,
            title: "OCI Card",
            description: "Manage Your Overseas Citizenship Effortlessly.",
        },
    ];
    const services = [
        {
            icon: FileText,
            title: 'End-To-End Documentation',
            description: 'We advise on all required documents,prepares formats, and manages the complete documentation on behalf of your company.'
        },
        {
            icon: Shield,
            title: 'Visa & Immigration Compliance',
            description: '– Extensions, registrations, and endorsements managed with accuracy and professionalism.'
        },
        {
            icon: BadgeCheck,
            title: 'Police Verification Assistance',
            description: 'Complete support during verification and coordination with authorities.'
        },
        {
            icon: MessageSquare,
            title: 'Liaison & Follow-Up',
            description: 'Complete support during verification and coordination with authorities.'
        },
        {
            icon: Users,
            title: 'On-Ground Support',
            description: 'Assistance during applicant presence at FRO or Police Station (as per government requirement).'
        },
        {
            icon: Clock,
            title: 'Time-Bound Execution',
            description: 'Processes explained clearly in advance and completed within the committed timeframe.'
        }
    ];
    return (
        <>
            {loading ? (
                <Loader animation={VisaAnimation} size={400} bgColor="gray-100" />
            ) : (
                <div>

                    <section className="bg-[#F5E9D6] relative">
                        <div
                            className="flex items-center justify-center min-h-[50vh] sm:min-h-[60vh] md:min-h-[50vh] lg:min-h-[100vh] bg-cover bg-top relative "
                            style={{ backgroundImage: `url(${visa})` }}
                        >
                            <div className="absolute inset-0 bg-black/50"></div>

                            <div className='flex justify-center mt-10'>

                                <div className="flex flex-col items-center justify-center text-center relative z-10 px-4 ">
                                    <h1 className="animate-h1  font-medium md:font-bold text-xl md:text-5xl lg:text-6xl text-white mb-4 tracking-wider ">
                                        VISA & IMMIGRATION ASSISTANCE
                                    </h1>
                                    <h2 className="animate-h2 font-['Rufina'] font-light text-medium md:text-2xl text-[#F5F3F1] mb-12 max-w-3xl leading-relaxed">
                                        Hassle-free visa support with AJ Hospitality & VFS Global
                                    </h2>
                                    <button
                                        onClick={() => navigate('/visa-application')}
                                        className="animate-btn flex items-center gap-2 bg-[#5B656F] hover:bg-slate-600 text-white font-['Raleway'] py-3 px-8 md:py-4 md:px-10 rounded-lg duration-300 text-medium  md:text-lg tracking-wide"
                                    >
                                        Apply For Visa support
                                        <FiArrowUpRight className="text-xl" />
                                    </button>
                                </div>
                            </div>

                        </div>
                    </section>
                    <section>
                        <div className="bg-gradient-to-b from-[#F5E9D6] to-white py-16 px-4">
                            <div className="max-w-7xl mx-auto">
                                {/* Partnership Section */}
                                {/* <div className="text-center mb-10 ">
                            <h2 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-6 font-['Raleway]">
                                A Partnership Built On Trust
                            </h2>
                            <p className="text-[#181D24] text-base md:text-lg max-w-4xl mx-auto leading-relaxed font-['Rufina]">
                                AJ Hospitality Has Partnered With VFS Global, A Trusted Leader In Visa Processing With Over
                                25+ Years Of Experience. This Collaboration Ensures Reliable And Efficient Visa Assistance,
                                Providing Dedicated Support Throughout Your Application Process.
                            </p>
                        </div> */}


                                <div className="text-center mb-12">
                                    <h3 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 ">
                                        VFS Global
                                    </h3>
                                    <p className="text-[#181D24] text-base md:text-lg max-w-4xl mx-auto leading-relaxed">
                                        VFS Global is a visa and passport administration outsourcing company for governments
                                        and diplomatic missions. The company manages non-judgmental and administrative tasks
                                        related to applications for visa, passport, and consular services for its governments all over
                                        the world.
                                    </p>
                                    <p className="text-[#181D24] text-base md:text-lg max-w-4xl mx-auto leading-relaxed py-5">
                                        AJ Hospitality are tied up with VFS Global Services and we offer support in the application
                                        of the following Visa’s:
                                    </p>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                                    {visaTypes.map((visa, index) => (
                                        <div
                                            key={index}
                                            className="bg-white rounded-lg p-8 shadow-md hover:shadow-2xl transition-shadow duration-300 flex flex-col items-center text-center rounded-br-[40px]"
                                        >
                                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gray-200 mb-3">
                                                {visa.icon}
                                            </div>
                                            <h4 className="text-xl font-semibold text-gray-900 mb-3">
                                                {visa.title}
                                            </h4>
                                            <p className="text-gray-600 text-sm leading-relaxed">
                                                {visa.description}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className='bg-gradient-to-b from-white to-[#F5E9D6] '>
                        <div className=' mx-auto py-16 px-4 md:px-4 lg:px-0'>
                            <div className="max-w-7xl mx-auto">
                                <div className="bg-white rounded-bl-[60px] rounded-tr-[60px] shadow-2xl
                         overflow-hidden">
                                    <div className="flex flex-col md:flex-row">
                                        <div className="w-full md:max-w-5xl   bg-gradient-to-br from-gray-50 to-gray-100">
                                            <img
                                                src={chandr2}
                                                alt="Chandrashekhar S Wagh"
                                                className="w-full h-[300px] md:h-[350px] lg:h-[350px] object-cover"
                                            />
                                        </div>

                                        <div className="p-8 md:p-12 flex flex-col justify-center">
                                            <h2 className="text-sm  md:text-3xl  font-normal text-[#000000] uppercase tracking-wider mb-3 font-['Raleway']">
                                                Meet Your Expert Advisor
                                            </h2>

                                            <h3 className="text-2xl font-medium md:font-[550]  text-gray-900 mb-2 font-['Lora'] ">
                                                Chandrashekhar S Wagh
                                            </h3>

                                            <p className="text-base font-medium text-[#000000] mb-4 font-['Lora'] ">
                                                Trusted Visa Advisor
                                            </p>

                                            <p className="text-sm text-[#000000] leading-relaxed font-['Rufina']  ">
                                                Chandrashekhar s Wagh, a trusted tourism professional with over 25 years of experience, will advise and assist the guests with their application for an Indian visa. Backed by
                                                a dedicated team, established processes, and strong government contacts, the company pride’s
                                                itself on providing hassle-free, reliable, and timely services tailored to the needs of our
                                                visiting guests.
                                            </p>
                                            <div className="space-y-4 p-3 md:p-0 lg:p-3">
                                                <p className="text-sm font-medium text-gray-900 mb-3">
                                                    For assistance and advice, please contact Chandrashekhar on the following:
                                                </p>

                                                <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
                                                    {/* Phone */}
                                                    <a
                                                        href="tel:+919886049632"
                                                        className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
                                                    >
                                                        <Phone className="w-5 h-5 text-blue-600" />
                                                        <span className="text-sm">+91 8530255598</span>
                                                    </a>

                                                    <a
                                                        href="mailto:murartravel@gmail.com"
                                                        className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
                                                    >
                                                        <Mail className="w-5 h-5 text-blue-600" />
                                                        <span className="text-sm">hospitality@ajpgroup.com</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                    <section className="bg-gradient-to-b from-[#F5E9D6] to-white  py-16 px-4">
                        <div className="max-width mx-auto">
                            {/* Header */}
                            <div className="text-center mb-12">
                                <h2 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 ">
                                    Our Comprehensive Services
                                </h2>
                                <p className="text-[#181D24] text-base md:text-lg max-w-4xl mx-auto leading-relaxed">
                                    We Handle Every Detail of Your Visa Application Process
                                </p>
                            </div>

                            {/* Services Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                                {services.map((service, index) => {
                                    const Icon = service.icon;
                                    return (
                                        <div
                                            key={index}
                                            className="bg-white rounded-tl-[40px] p-6  shadow-md hover:shadow-2xl transition-shadow duration-300"
                                        >
                                            <div className="flex items-start gap-4">
                                                <div className="flex-shrink-0">
                                                    <Icon className="w-6 h-6 text-gray-700" strokeWidth={1.5} />
                                                </div>
                                                <div>
                                                    <h3 className="font-semibold text-gray-900 mb-2 text-base">
                                                        {service.title}
                                                    </h3>
                                                    <p className="text-gray-600 text-sm leading-relaxed">
                                                        {service.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </section>
                    <section>
                        <div className="min-h-screen bg-gradient-to-b from-[white] to-[#F5E9D6] flex items-center justify-center p-4 sm:p-6 lg:p-8">
                            <div className="bg-[#FFFBF4] rounded-tr-[40px] rounded-bl-[40px] shadow-lg max-w-6xl w-full p-8   sm:p-12">
                                <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 ">
                                    <div>
                                        <h1 className="text-3xl font-bold font-[Raleway] text-gray-900 mb-2">Visa Application</h1>
                                        <p className="text-gray-600 mb-8 font-[Rufina] ">
                                            Please fill out the form below with your information
                                        </p>

                                        <form onSubmit={handleSubmit} className="space-y-6  font-[Raleway]">
                                            <div className="grid sm:grid-cols-2 gap-4">
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        name="fullName"
                                                        value={formData.fullName}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Full Name
                                                    </label>
                                                </div>
                                                <div className="relative">
                                                    <input
                                                        type="tel"
                                                        name="phoneNumber"
                                                        value={formData.phoneNumber}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Phone Number
                                                    </label>
                                                </div>
                                            </div>

                                            <div className='grid sm:grid-cols-2 gap-4'>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        name="address"
                                                        value={formData.address}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Address
                                                    </label>
                                                </div>
                                                <div className="grid sm:grid-cols-2 gap-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            name="age"
                                                            value={formData.age}
                                                            onChange={handleChange}
                                                            className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                            required
                                                        />
                                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                            Age
                                                        </label>
                                                    </div>
                                                    <div className="relative">
                                                        <select
                                                            name="gender"
                                                            value={formData.gender}
                                                            onChange={handleChange}
                                                            className="w-full border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-gray-600 px-3 py-3 text-[10px] appearance-none"
                                                            required
                                                        >
                                                            <option value="">Select Gender</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                            <option value="other">Other</option>
                                                        </select>
                                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                            Gender
                                                        </label>
                                                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex flex-col sm:grid sm:grid-cols-2 gap-4">
                                                <div className="relative flex-1">
                                                    <select
                                                        name="visaType"
                                                        value={formData.visaType}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-gray-600 px-3 py-3 text-[10px] appearance-none"
                                                        required
                                                    >
                                                        <option value="">Select Visa Type</option>
                                                        <option value="tourist">Tourist</option>
                                                        <option value="business">Business</option>
                                                        <option value="student">Student</option>
                                                        <option value="work">Work</option>
                                                    </select>
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Visa Type
                                                    </label>
                                                </div>

                                                <div className="relative flex-1">
                                                    <input
                                                        type="text"
                                                        name="travel"
                                                        value={formData.travel}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Travel (alone/with others?)
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="grid sm:grid-cols-2 gap-4">
                                                <div className="relative">
                                                    <input
                                                        type="date"
                                                        name="travelStartDate"
                                                        value={formData.travelStartDate}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] "
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Travel Start Date
                                                    </label>
                                                </div>
                                                <div className="relative">
                                                    <input
                                                        type="date"
                                                        name="travelEndDate"
                                                        value={formData.travelEndDate}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] "
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Travel End Date
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="relative">
                                                <textarea
                                                    name="reasonForTravel"
                                                    value={formData.reasonForTravel}
                                                    onChange={handleChange}
                                                    rows="3"
                                                    className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] resize-none"
                                                    required
                                                />
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Reason for Travel
                                                </label>
                                            </div>

                                            <div className="relative">
                                                <textarea
                                                    name="pastVisaRejections"
                                                    value={formData.pastVisaRejections}
                                                    onChange={handleChange}
                                                    rows="2"
                                                    className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] resize-none"
                                                />
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Past Visa Rejections (if any)
                                                </label>
                                            </div>

                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="fastTrackServices"
                                                    checked={formData.fastTrackServices}
                                                    onChange={handleChange}
                                                    id="fastTrack"
                                                    className="w-4 h-4 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-400"
                                                />
                                                <label htmlFor="fastTrack" className="ml-2 text-sm text-gray-700">
                                                    Fast Track Services
                                                </label>
                                            </div>
                                            {showSuccess && (
                                                <div className="mb-4 p-3 bg-green-100 text-green-700 text-center rounded-lg">
                                                    Form submitted successfully!
                                                </div>
                                            )}

                                            <button
                                                type="submit"
                                                className="w-full bg-[#5B656F] hover:bg-[#3a4558] text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                            >
                                                Submit Application
                                                <FiArrowUpRight className="text-xl" />

                                            </button>
                                        </form>
                                    </div>
                                    <div className="hidden lg:flex items-center justify-center">
                                        <div className="relative w-full h-full min-h-[500px]">
                                            <img
                                                src={form}
                                                alt="Travel map with sunglasses and accessories"
                                                className="w-full h-full object-fit rounded-tr-[40px] rounded-bl-[40px]"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                </div>

            )}
        </>
    )
}

export default Visa
